<template>
    <vx-card :title="fullName" :subtitle="staff.jobTitle">
        <template slot="actions">
            <div v-if="!hideImage" class="profile-img-container">
                <!-- <user-avatar
                    class="user-avatar"
                    :class="{ 'mr-6': !!$slots.actions }"
                    :staff="staff"
                /> -->
            </div>
            <slot name="actions"> </slot>
        </template>

        <vx-tabs v-model="activeTab" hide-tabs position="top" class="tabs-shadow-none w-full">
            <vs-tab>
                <!-- <staff-info :staff="staff">
                    <template slot="extra-info">
                        <template v-if="isIsr">
                            <h6>Assigned BDMs</h6>
                            <div v-if="assignedBdms.any()" class="flex w-full flex-wrap mt-1">
                                <user-chip
                                    v-for="bdm in sortedBdms"
                                    :key="bdm.id"
                                    :staff="bdm"
                                    quick-look
                                    :align="alignment"
                                />
                            </div>
                            <span v-else class="text-danger"> None assigned </span>
                        </template>
                        <template v-if="isBdm">
                            <h6>Primary ISR</h6>
                            <user-chip
                                v-if="assignedIsr"
                                class="mt-1"
                                :staff="assignedIsr"
                                quick-look
                            />
                            <span v-else class="text-danger"> Unassigned </span>
                        </template>
                    </template>
                </staff-info> -->
            </vs-tab>
            <template v-if="hasManageRolePermission">
                <vs-tab>
                    <div style="height: 300px">
                        <vx-scroll-area>
                            <!-- <staff-role :user-id="staff.id" :roles="staff.roles" /> -->
                        </vx-scroll-area>
                    </div>
                </vs-tab>
                <vs-tab>
                    <div v-if="isIsr" style="height: 300px">
                        <vx-scroll-area>
                            <!-- <bdm-assigner :isr="staff" class="w-full" /> -->
                        </vx-scroll-area>
                    </div>
                </vs-tab>
            </template>
        </vx-tabs>
        <template slot="footer">
            <div class="flex flex-wrap justify-end mt-2 gap-3">
                <template v-if="!hideManagementOptions && hasManageRolePermission">
                    <vx-button
                        v-if="isIsr && showInfo"
                        icon="icon-user-plus"
                        icon-pack="feather"
                        type="filled"
                        @click="showBdmEditor = true"
                        color="warning"
                    >
                        BDM List
                    </vx-button>
                    <vx-button
                        v-if="showInfo"
                        icon="icon-user-plus"
                        icon-pack="feather"
                        color="primary"
                        type="filled"
                        @click="showRoleEditor = true"
                    >
                        Manage Roles
                    </vx-button>

                    <vx-button
                        v-if="!showInfo"
                        color="warning"
                        type="filled"
                        @click="showInfo = true"
                    >
                        Back
                    </vx-button>
                </template>

                <vx-action-icon
                    v-if="showInfo && (isCurrentUser || hasManageRolePermission)"
                    icon="EditIcon"
                    is-button
                    color="warning"
                    @click="showProfileEditPrompt = true"
                />
            </div>
        </template>
        <!-- <edit-profile-prompt
            v-if="showProfileEditPrompt"
            :active="showProfileEditPrompt"
            :profile="staff"
            @close="showProfileEditPrompt = false"
        /> -->
    </vx-card>
</template>

<script>
import { mapGetters } from 'vuex'
// import StaffInfo from './StaffInfo.vue'
// import StaffRole from './Roles/StaffRole.vue'
// import UserAvatar from '../UserAvatar.vue'
// import BdmAssigner from './Bdms/BdmAssigner.vue'
// import UserChip from '../UserChip.vue'
// import EditProfilePrompt from '../EditProfilePrompt.vue'

export default {
    name: 'user-profile-card',
    components: {
        // StaffInfo,
        // StaffRole,
        // UserAvatar,
        // BdmAssigner,
        // UserChip,
        // EditProfilePrompt,
    },
    props: {
        staff: {
            type: Object,
            required: true
        },
        hideManagementOptions: {
            type: Boolean,
            default: true
        },
        hideImage: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showProfileEditPrompt: false,
            doNotDistributeText: 'Do not distribute',
            activeTab: 0,
            manageRolePermission: ['SuperUser', 'UserAdmin'],
            alignment: 'top'
        }
    },
    watch: {
        staffId: {
            handler: function (newV, oldV) {
                this.showInfo = true
            },
            immediate: true
        }
    },
    computed: {
        staffId() {
            return this.staff.id
        },
        fullName() {
            if (this.loading) {
                return 'Loading...'
            }
            return this.getFullName(this.staff)
        },
        ...mapGetters({
            theme: 'user/theme',
            userInfo: 'user/profile',
            getUserById: 'staff/getById'
        }),
        isCurrentUser() {
            return this.userInfo.id == this.staff.id
        },
        userRoles() {
            return this.userInfo.roles || []
        },
        hasManageRolePermission() {
            return this.userRoles.any((x) => this.manageRolePermission.contains(x))
        },
        assignedBdms() {
            return this.staff.bdms.map(this.getUserById)
        },
        sortedBdms() {
            return this.assignedBdms.defaultSort(this.getFullName)
        },
        assignedIsr() {
            return this.getUserById(this.staff.isrId)
        },
        isIsr() {
            return this.staff.roles.contains('ISR')
        },
        isBdm() {
            return this.staff.roles.contains('BDM')
        },
        showRoleEditor: {
            get() {
                return this.activeTab == 1
            },
            set(v) {
                this.activeTab = v ? 1 : 0
            }
        },
        showBdmEditor: {
            get() {
                return this.activeTab == 2
            },
            set(v) {
                this.activeTab = v ? 2 : 0
            }
        },
        showInfo: {
            get() {
                return this.activeTab == 0
            },
            set(v) {
                this.activeTab = 0
            }
        }
    },
    methods: {
        getFullName(bdm) {
            return `${bdm.firstName} ${bdm.lastName}`
        }
    }
}
</script>

<style scoped>
.profile-img-container {
    height: 30px;
    width: 30px;
    position: relative;
}
.user-avatar {
    right: 0px;
    top: -35px;
    position: absolute;
    z-index: 500;
}
</style>
